import Typography from "@mui/material/Typography";
import TableDisplay from "../../TableDisplay/TableDisplay";
import { blueShade, blueShade2, brandColumn, unitColIdentifier } from "../../data";
import grey from "@mui/material/colors/grey";
import { projectionTableColumns } from "./data";
import { Box } from "@mui/material";
import BlackBorderTable from "../TableLayouts/BlackBorderTable/BlackBorderTable";

const ProjectionTable = ({ mode, tableRows = [], setTableRows, customGroupBorderBottom, rowSpanColumns }) => {
	const unitRow = Object.values(projectionTableColumns)?.reduce(
		(acc, row) => {
			acc[row.key] = row?.unit ?? "";
			return acc;
		},
		{ [unitColIdentifier]: "units" }
	);
	return (
		<BlackBorderTable
			sx={{
				flexGrow: 1,
				border: "0px",
				p: "0px",
				// borderTop: `2px solid ${blueShade2}`
			}}
			disableBorder>
			{/* <Typography textAlign="center" sx={{ background: grey[800], color: "white" }} height="24px" width="100%">
				{mode ?? "GP WITH CH MARGIN"}
			</Typography> */}
			<TableDisplay
				disableTableBorder
				columns={Object.values(projectionTableColumns)}
				rows={[unitRow, ...tableRows]}
				rowHeight="30px"
				// columnWidth="85px"
				rowSpanColumns={rowSpanColumns}
				customGroupBorderBottom={customGroupBorderBottom}
			/>
		</BlackBorderTable>
	);
};

export default ProjectionTable;
